export default {
  "checkinRecord.title": "签到记录",
  "checkinRecord.column.no": "#序号",
  "checkinRecord.column.userId": "用户ID",
  "checkinRecord.column.email": "邮箱",
  "checkinRecord.column.name": "姓名",
  "checkinRecord.column.firstName": "名",
  "checkinRecord.column.lastName": "姓",
  "checkinRecord.column.totalCheckinCount": "会员签到累计",
  "checkinRecord.column.monthlyCheckinCount": "当月签到累计",
  "checkinRecord.column.sevenDayStreak": "7天连续天数",
  "checkinRecord.column.currentStreak": "已连续签到天数",
  "checkinRecord.column.todayCheckinStatus": "当天签到状态",
  "checkinRecord.column.rewardType": "当天获得奖品类型",
  "checkinRecord.column.rewardAmount": "当天获得奖品奖励数量",
  "checkinRecord.column.lastCheckinTime": "最后签到时间",
  "checkinRecord.status.notCheckedIn": "未签到",
  "checkinRecord.status.checkedIn": "已签到",
  "checkinRecord.search.userId": "用户ID",
  "checkinRecord.search.email": "邮箱",
  "checkinRecord.tooltip.copy.userId": "复制用户ID: {text}",
  "checkinRecord.copy.success": "已复制到剪贴板",
};
